import { render } from "./TheSpinner.vue?vue&type=template&id=39372d72&scoped=true"
const script = {}

import "./TheSpinner.vue?vue&type=style&index=0&id=39372d72&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39372d72"]])

export default __exports__